export const productHeaderGalleryGql = /* GraphQL */ `
... on landingPageContent2023_productHeaderGallery_BlockType {
    typeHandle
    sectionTitle
    description
    theme
    links:lpProductHeaderGalleryLinks {
        ... on lpProductHeaderGalleryLinks_BlockType {
            linkStyle:lpProductHeaderGalleryLinksStyle
            enableModal:lpProductHeaderGalleryLinksEnableModal
            disclaimerFootnote:lpProductHeaderGalleryLinksDisclaimerFootnote {
                ... on disclaimerFootnote_disclaimerFootnote_Entry {
                    content:disclaimercontent
                }
            }
            link:lpProductHeaderGalleryLink {
                ariaLabel
                customText
                url
                target
                text
                element {
                    title
                    ... on videos_Asset {
                        videoId
                        videoSource
                    }
                    ... on videoUploads_Asset {
                        videoUrl:url
                    }
                }
            }
        }
    }
    media {
        ... on images_Asset {
            title
            altText
            caption
            cardDescription
            thumbnailSize:galleryThumbnail {
                srcset
                srcWebp
            }
            fullSize:lpImageTextUncropped {
                srcWebp
                srcset
            }
        }
    }
}`;
